import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Fronts extends Component {
  render() {
    return (
      <EntityList apiRoute='api/fronts' title='Remorque - Devants' editTitle='Devant' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Fronts;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/fronts.js
 **/